// TODO - remove lint disable when editing this file
/* eslint-disable */
import { get, has } from 'lodash'

export const categories = [
  'staff',
  'freelance',
  'wires',
  'stock',
  'handout',
  'other',
]

export const getDistributors = () => {
  return fetch('/settings/api/v1/distributor/content-type/story', {
    credentials: 'same-origin',
  }).then((response) => response.json())
}

export const getDistributorFromDistributorList = (
  referenceId,
  distributorList
) => {
  const distributor = distributorList.find(
    (distributor) => distributor.id === referenceId
  )

  return distributor
}

export const populateDistributorFieldsFromSource = (storyANS) => {
  //  this function mutates the passed in storyANS parameter

  if (get(storyANS, 'distributor.mode') === 'reference') {
    delete storyANS.distributor.mode
    delete storyANS.distributor.reference_id
  }

  storyANS.distributor = storyANS.distributor || {}
  storyANS.distributor.name = storyANS.source.name

  if (categories.indexOf(storyANS.source.source_type) > -1) {
    storyANS.distributor.category = storyANS.source.source_type
    storyANS.distributor.subcategory = ''
  } else {
    storyANS.distributor.category = 'other'
    storyANS.distributor.subcategory = storyANS.source.source_type
  }

  return storyANS
}

export const populateSourceFieldsFromDistributor = (storyANS, distributor) => {
  //  this function mutates the passed in storyANS parameter

  storyANS.source = storyANS.source || {}
  storyANS.source.name = distributor.name

  storyANS.source.source_type = distributor.subcategory
    ? distributor.subcategory
    : distributor.category

  return storyANS
}

export const shouldPopulateDistributor = (storyANS) => {
  // If 1) distributor has the mode property (new content restriction implementation)
  // or 2) the distributor name is present,
  // or 3) there is no source name,
  // then don't populate distributor from the legacy source data

  const shouldNotPopulate =
    has(storyANS, 'distributor.mode') ||
    !!get(storyANS, 'distributor.name') ||
    !get(storyANS, 'source.name')

  return !shouldNotPopulate
}
